// 📁 Imports

// 💾 Variables
const alertsCloseButton = document.querySelectorAll("[data-alert-close]");
const showClass = "alert--state-show";

// 📐 Functions
const alertShow = (el, heading, message) => {
  const headingEl = el.querySelector("[data-alert-heading]");
  const contentEl = el.querySelector("[data-alert-contnet]");
  
  if (heading && headingEl) {
    headingEl.innerHTML = heading;
  }
  
  if (message && contentEl) {
    contentEl.innerHTML = message;
  }
  el.classList.add(showClass);

  setTimeout(() => {
    alertHide(el);
  }, 5000);
};

const alertHide = (el) => {
  el.classList.remove(showClass);
};

// 🖱️ Event listener
if (alertsCloseButton.length !== 0) {
  Array.from(alertsCloseButton).forEach((button) => {
    const alertWrapper = button.closest("[data-alert]");
    alertWrapper.addEventListener("click", () => {
      alertHide(alertWrapper);
    });
  });
}

export { alertShow, alertHide };
